export const isSaleActive = ({
  price,
  salePrice,
  saleStartAt,
  saleEndAt,
  now = new Date(),
}) => {
  const base = Number(price ?? 0);
  const sale = Number(salePrice ?? 0);
  if (!(sale > 0 && sale < base)) return false;

  const start = saleStartAt ? new Date(saleStartAt) : null;
  if (start && !Number.isNaN(start.getTime()) && now < start) return false;

  const end = saleEndAt ? new Date(saleEndAt) : null;
  if (end && !Number.isNaN(end.getTime()) && now > end) return false;

  return true;
};

export const getEffectivePrice = ({
  price,
  salePrice,
  saleStartAt,
  saleEndAt,
  now = new Date(),
}) => {
  const base = Number(price ?? 0);
  return isSaleActive({ price: base, salePrice, saleStartAt, saleEndAt, now })
    ? Number(salePrice ?? 0)
    : base;
};
